/**
 * Reading a form.
 *
 * `FormData.get` returns a string *or a `File`*, and the difference matters here more than it
 * usually does: the forms in this app carry mailbox passwords and API keys, and coercing whatever
 * came back with `String(...)` would turn an unexpected entry into the text `[object File]` and
 * store it as somebody's password. So a non-string is treated as absent, which fails the request
 * rather than saving a value nobody typed.
 */

/** The trimmed text of a field, or `''` when it is absent or is not text. */
export function formText(data: FormData, name: string): string {
  const value = data.get(name);
  return typeof value === 'string' ? value.trim() : '';
}

/**
 * The exact text of a field, untrimmed.
 *
 * Passwords are read with this: a trailing space is a character the provider will check, and
 * silently removing it produces a login failure nobody can explain.
 */
export function formSecret(data: FormData, name: string): string {
  const value = data.get(name);
  return typeof value === 'string' ? value : '';
}

/** Whether a checkbox is ticked. */
export function formFlag(data: FormData, name: string): boolean {
  return data.get(name) === 'on';
}
